<template>
	<div class="BarAbstract">
		<slot/>
	</div>
</template>

<script>
	import { Component, Vue } from 'vue-property-decorator';
	import KeyListenerView from '../KeyListenerView';

	@Component({
		components: {
		},
	})
	export default class BarAbstract extends KeyListenerView {
        mounted() {
        	super.mounted();
    	}

    	destroyed() {
        	super.destroyed();
    	}
	}
</script>

<style lang="scss" scoped>
.BarAbstract {
	background: #A0A0A8;
	padding: 0.2vmin 2vmin;
	overflow: hidden;
}
</style>